import ConfiguracoesModulosPage from "@/Pages/Administracao/ConfiguracoesModulosPage.vue";
import store from "@/store";
import authService from "@/Services/AuthService";

const ROLES_ADMIN = ["admin", "super-admin", "TI"];

async function somenteAdmin(to, from, next) {
  let user = store.getters["Auth/user"];
  if (!user && authService.isLoggedIn()) {
    try {
      await authService.syncUserWithStore();
    } catch (e) {
      // ignore
    }
    user = store.getters["Auth/user"];
  }
  if (!ROLES_ADMIN.includes(user?.roleName)) {
    return next({ name: "NaoAutorizado" });
  }
  return next();
}

export default [
  {
    path: "/administracao/configuracoes",
    name: "administracao.configuracoes",
    component: ConfiguracoesModulosPage,
    beforeEnter: somenteAdmin,
  },
];
